import { PRODUCT_IDS } from '@adsk/alloy-provider';

const adminProductIds = [
  PRODUCT_IDS.PROJECT_ADMINISTRATION,
  PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
];

export default (products = []) => {
  const firstAdminProduct = products.find((product) =>
    adminProductIds.includes(product.key)
  );

  if (products[0] === firstAdminProduct) return undefined;

  return firstAdminProduct?.key;
};
